module.exports = __webpack_public_path__ + "img/login_tab04_03.1abdfd4e.png";